import { render, staticRenderFns } from "./NegativeFeedbackComment.vue?vue&type=template&id=22dd2db0&scoped=true"
import script from "./NegativeFeedbackComment.vue?vue&type=script&lang=js"
export * from "./NegativeFeedbackComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd2db0",
  null
  
)

export default component.exports